module.exports = __webpack_public_path__ + "static/mentor-avelo-a105f84ba128c33f4673e90954b085c7.jpg";